import { useEffect } from "react";

export default function useAutoScrollBottom() {
  useEffect(() => {
    window.scrollTo(0,document.body.scrollHeight);
  },[])
}